import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2, MessageCircle } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-brand-dark text-white pt-8 pb-12 px-4 md:pt-20 md:pb-24 overflow-hidden" data-id="element-122">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-123">
        {/* Badge */}
        <div className="text-center mb-4" data-id="element-124">
          <div className="inline-block bg-brand-pink/20 text-brand-pink px-4 py-1.5 rounded-full text-sm font-semibold border border-brand-pink/30" data-id="element-125">
            Mamá Digital 2.0
          </div>
        </div>

        {/* Hero Image - First on Mobile */}
        <div className="flex justify-center mb-6 md:hidden" data-id="element-126">
          <div className="relative max-w-sm w-full" data-id="element-127">
            <img src="https://cdn.magicpatterns.com/uploads/n8RHDFVDB9kyRkRG685Gie/heylloyd-image-1768698564084.png" alt="Mamá Digital 2.0 en tablet" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-128" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-129">
          {/* Left Column - Text Content */}
          <div className="text-center md:text-left" data-id="element-130">
            {/* Headline */}
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-4 tracking-tight" data-id="element-131">
              Crea y vende tu primer PDF en 7 días —{' '}
              <span className="text-brand-pink" data-id="element-132">usando solo tu celular</span>
            </h1>

            <p className="text-lg md:text-2xl text-gray-300 mb-6 font-medium" data-id="element-133">
              (aunque hoy no tengas idea qué vender)
            </p>

            {/* Subheadline/Lead */}
            <p className="text-base md:text-xl text-gray-400 mb-8 leading-relaxed" data-id="element-134">
              Una guía paso a paso para mamás jóvenes que quieren generar
              ingresos desde casa sin inventario, sin diseño y sin "ser
              expertas"… usando herramientas gratuitas como{' '}
              <span className="text-white font-bold" data-id="element-135">Heylloyd</span> +{' '}
              <span className="text-white font-bold" data-id="element-136">Gamma App</span>.
            </p>

            {/* CTA - Prominent on Mobile */}
            <div className="mb-8 md:mb-10" data-id="element-137">
              <Button onClick={scrollToPricing} className="w-full md:w-auto text-lg md:text-xl px-8 py-4 md:py-5 bg-brand-pink hover:bg-rose-400 text-brand-dark font-bold border-none" data-id="element-138">
                Quiero mi guía "Mamá Digital 2.0"
              </Button>
              <p className="text-xs md:text-sm text-gray-500 flex items-center justify-center md:justify-start gap-2 mt-3" data-id="element-139">
                <MessageCircle className="w-4 h-4 text-brand-pink" data-id="element-140" />
                Descarga inmediata • Hecho para principiantes • 100% desde el
                celular
              </p>
            </div>

            {/* Bullets - After CTA on Mobile */}
            <div className="grid gap-3" data-id="element-141">
              {["Elimina la parálisis de 'no sé qué hacer'", 'Crea un PDF que se vea profesional', 'Aprende a vender por WhatsApp + Instagram', 'Plan de 7 días (1–2 horas al día)'].map((item, i) => <div key={i} className="flex items-start text-left" data-id="element-142">
                  <CheckCircle2 className="w-5 h-5 text-brand-pink mt-1 mr-2 flex-shrink-0" data-id="element-143" />
                  <span className="text-gray-300 text-sm md:text-base" data-id="element-144">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Right Column - Hero Image (Desktop Only) */}
          <div className="hidden md:flex justify-center md:justify-end" data-id="element-145">
            <div className="relative max-w-md w-full" data-id="element-146">
              <img src="https://cdn.magicpatterns.com/uploads/n8RHDFVDB9kyRkRG685Gie/heylloyd-image-1768698564084.png" alt="Mamá Digital 2.0 en tablet" className="w-full h-auto rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-300" data-id="element-147" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}